import list_icon from '@/assets/img/device/fe87/icon.png'
import { DevicePid, KK } from '@/define/define'
import { na87VKCodes } from '../keycode/vkeycode'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { FE87V2 } from './fe87_v2'
import { adjustableKeys } from '@libs/define/adjustable_keys'

export class FE87V2Pro extends FE87V2 {
  name: string = 'Fe87_V2_IMC'
  icon: string = list_icon
  width: number = 777
  magneticAxis: boolean = true
  configurableMagneticAxis: number[] = adjustableKeys(DevicePid.IrokFe87V2IMC) // 混合轴，只允许七颗磁轴配置，其它机械轴不允许配置

  superResponse: boolean = false
  inoperableKeys: KK[] = [0x55, 0x00]
  vkcodes = na87VKCodes
  square = getDeviceKeySquare(DevicePid.IROKNA87)
}
